import React from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

type Props = {
  tip?: string;
};

export const LoadingPage: React.FC<Props> = ({ tip }) => {
  return (
    <div className="flex w-full my-20 justify-center">
      <Spin
        size="large"
        tip={tip}
        indicator={
          <LoadingOutlined
            style={{ fontSize: 64, marginBottom: "16px" }}
            spin
          />
        }
      />
    </div>
  );
};
